<app-badge
  [small]="small"
  [noTextMobile]="noTextMobile"
  [ngClass]="getBadgeClass()">

  <ng-container *ngIf="hasCancellationRequest; else regularStatus">
    {{ getBadgeText() }}
  </ng-container>

  <ng-template #regularStatus>
    <!-- Trial status with days left -->
    <ng-container *ngIf="subscription.status === 'trial'">
      <ng-container *ngIf="showTrialStatusAsCurrent; else trialDaysLeft">
        {{ 'billing.subscriptionStatusCurrent' | translate }}
      </ng-container>
      <ng-template #trialDaysLeft>
        {{ subscription.status | titlecase }}
        <ng-container *ngIf="!trialLabelOnly">
          <span class="days-left-container">-</span>
          <b class="days-left-container">
            {{ 'common.daysLeft' | translate:{ count: subscription.remainingTrialDays } }}
          </b>
        </ng-container>
      </ng-template>
    </ng-container>

    <!-- Other statuses -->
    <ng-container *ngIf="subscription.status !== 'trial'">
      <ng-container *ngIf="shouldTranslate(); else noTranslate">
        {{ getBadgeText() | translate | titlecase }}
      </ng-container>
      <ng-template #noTranslate>
        {{ getBadgeText() }}
      </ng-template>
    </ng-container>
  </ng-template>
</app-badge>
